
import { Component, Vue } from 'vue-property-decorator'
import faceConfirm from './faceConfirm.vue'
import BgComp from '../components/bgComp.vue'
import { downloadUrl } from '@/utils/util'
import { Getter } from 'vuex-class'
import {
  getIDCardByOCR,
  addIDCard,
  getIDCard,
  getCompanyInfo,
  getOutDataShuZhunBaoV3
} from '@/api/approve'
import { backToBefore } from '@/utils/h5ToApp'
import AddrPopup from '@/views/company/template/AddrPopup.vue'

@Component({
  name: 'CompanyInfoForm',
  components: {
    faceConfirm,
    BgComp,
    AddrPopup
  }
})
export default class CompanyInfoForm extends Vue {
  @Getter mobile!: string
  @Getter userId!: string
  @Getter companyId: string // 公司编号
  @Getter companyName: string // 公司名称

  labelWidth = '9em'
  formData = {
    companyName: '', // 公司名称
    unifiedSocialCreditCode: '', // 统一社会信用代码
    name: '', // 姓名
    identityCard: '', // 身份证号码
    businessLicense: '', // 营业执照地址
    success: 0 //  0 未认证 1 认证成功 2 认证失败
  }
  // 身份证照片列表
  fileA = ''
  fileB = ''
  // 身份证文件地址
  fileUrl = ''
  // 用户身份证信息
  userInfo = {}
  isSubmit = false
  // userId1
  userId1 = ''
  // 查看营业执照
  show = false
  // 企业是否认证
  isIdentification = 0

  get safetyHeight () {
    return this.$store.state.app.safetyHeight
  }

  created() {
    console.log('this.$route', this.$route)
  }
  mounted() {
    this.getCompanyInfo()
    this.getIDCard()
  }
  // 返回上一级
  handleBack() {
    if(this.$route.query.formPage==='h5'){
      console.log('调用h5');

      this.$router.back()
    }else {
      console.log('调用原生')
      backToBefore()
    }
  }
  // input输入限制（英文、数字）公司简称
  formatterInput(value) {
    let val = value.replace(/[^a-zA-Z\d]/g, '')
    return val.toUpperCase() // 英文和数字
    // return value.replace(/[^A-Z\d]/g, '') // 英文和数字
  }
  // 上传身份证
  uploadIDCard(IDCardType, fileType) {
    // A B

    if (this.formData.success === 1 && IDCardType !== 'C') {
      this.$toast('当前账号已完成个人实名认证,不可更改身份证信息')
      return
    }
    const data = {
      companyId: this.companyId,
      //  6订单附件 8身份证 9营业执照
      fileType: fileType
    }
    this.$bridge.callHandler('uploadFile', data, (res) => {
      const data = !res ? {} : JSON.parse(res)
      // this[`file${IDCardType}`] = downloadUrl(data.filePath)
      this[`file${IDCardType}`] = data.filePath
      this.fileUrl = data.filePath
      console.log('this.fileUrl', this.fileUrl)
      if (IDCardType !== 'C') {
        this.$toast({message:'已上传成功，正在识别身份信息…', duration:0})
        this.getIDCardByOCR(IDCardType)
      } else {
        this.formData.businessLicense = data.filePath
      }
    })
  }
  // 身份证信息识别
  getIDCardByOCR(IDCardType) {
    let params = {
      companyId: this.companyId, // 当前公司
      // 身份证照片 A正面，B反面
      cardType: IDCardType,
      // 身份证文件地址
      fileUrl: this.fileUrl
    }

    getIDCardByOCR(params)
      .then((res) => {
        console.log('res userApprove', res)
        if (IDCardType === 'A') {
          this.formData.name = res.data.name
          this.formData.identityCard = res.data.idcard
          this.userId1 = res.data.userId1
          this.userInfo = Object.assign(this.userInfo, res.data)
        } else {
          this.userInfo = Object.assign(this.userInfo, res.data)
        }
      })
      .catch((res) => {
        console.log('catch', res)
        if (IDCardType === 'A') {
          this.formData.name = ''
          this.formData.identityCard = ''
          this.fileA = ''
        } else {
          this.fileB = ''
        }
      }).finally(() => {
        // 上传完成后再关闭
        this.$toast.clear()
      })
  }
  // 获取公司信息
  getCompanyInfo() {
    let params = {
      companyId: this.companyId
    }
    getCompanyInfo(params).then((res) => {
      if (res.data) {
        this.formData.unifiedSocialCreditCode = res.data.unifiedSocialCreditCode
        this.formData.companyName = res.data.companyName
        this.formData.businessLicense = res.data.businessLicense
        this.isIdentification = res.data.isIdentification
      }
    })
  }
  // 获取身份信息
  getIDCard() {
    let params = {
      companyId: this.companyId
    }
    getIDCard(params).then((res) => {
      console.log('res', res)
      if (res.data) {
        this.formData.name = res.data.name
        this.formData.identityCard = res.data.idCard
        this.fileA = res.data.fileUrlA
        this.fileB = res.data.fileUrlB
        this.formData.success = res.data.success
      }
    })
  }
  // submit1() {
  //   // 更新app端企业认证标识
  //   this.$bridge.callHandler('updateApproveInfo', {}, (res) => {
  //     console.log('updateApproveInfo', res)
  //   })
  // }
  // 提交信息
  submit() {
    // this.$router.push({
    //           path: '/faceConfirm',
    //           query: {
    //             unifiedSocialCreditCode: this.formData.unifiedSocialCreditCode
    //           }
    //         })
    this.addIDCard()
  }
  // 保存/更新身份信息
  addIDCard() {
    console.log('fileUrl', this.fileA, this.fileB)

    let params = {
      companyId: this.companyId,
      ...this.formData,
      ...this.userInfo,
      fileUrlA: this.fileA,
      fileUrlB: this.fileB
    }

    addIDCard(params)
      .then((res) => {
        console.log('res',res);

        if (res.code === '000000') {
          this.handleForm()
        } else {
          this.$dialog
            .alert({
              title: '查询结果',
              message: res.msg
            })
            .then(() => {})
        }
      })
      .catch((res) => {
        console.log('catch', res)
      })
  }
  // 表单校验
  handleForm() {
    if (this.isSubmit) return false
    ;(this.$refs.companyInfoForm as any)
      .validate()
      .then(() => {
        this.isSubmit = true
        if (this.$checkIsEmpty(this.formData.businessLicense)) {
          this.$toast('请上传营业执照')
          return
        }
        if (!this.fileA || !this.fileB) {
          this.$toast('请上传身份证照片')
          return
        }
        this.$confirmDialog.show({
          okText: '确认',
          cancelText: '取消',
          tips: '企业认证需法定代表人本人认证，请确定为本人操作。',
          onOk: () => {
            let param = {
              userId2: this.userId,
              name: this.formData.name,
              mobile: this.mobile,
              idCard: this.formData.identityCard
            }
            getOutDataShuZhunBaoV3({
              ...param
            }).then((res: any) => {
              console.log('*4648464864', res)
              this.$router.push({
                path: '/faceConfirm',
                query: {
                  unifiedSocialCreditCode: this.formData.unifiedSocialCreditCode
                }
              })
            }).catch((res: any) => {
              this.$dialog.alert({
                title: '查询结果',
                message: res.data.msg
              }).then(() => {})
            })
          }
        })
      })
      .catch((res) => {
        this.$toast(res[0].name + '信息未输入，请输入')
      })
      .finally(() => {
        this.isSubmit = false
      })
  }
    /**
   * 公司基本信息的地址信息改变
   */
   handleAddrChange ({addressId, addressName}) {
    console.log("🚀 ~ CompanyInfoForm ~ handleAddrChange ~ addressName:", addressName)
    console.log("🚀 ~ CompanyInfoForm ~ handleAddrChange ~ addressId:", addressId)
    // this.$set(this.companyMsg, 'addressId', addressId)
    // this.$set(this.companyMsg, 'addressName', addressName)
  }
}
